<template>
  <div class="flex flex-col min-h-0 min-w-0 w-full h-full overflow-auto">
    <div
      class="border-b border-mid-neutral-50 h-14 flex items-center justify-between px-6 bg-white z-10 shrink-0"
    >
      <div class="flex items-center gap-4 text-dark-neutral-500">
        <RouterLink
          :to="goBackUrl"
          class="flex items-center gap-1 text-sm font-medium text-dark-neutral-400 hover:text-dark-neutral-600 focus:outline-none"
        >
          <span class="material-symbols-outlined text-base">arrow_back</span>
          <span>Back</span>
        </RouterLink>
        <div class="flex items-center gap-2">
          <span class="material-symbols-outlined">{{ icon }}</span>
          <h2 class="font-semibold">User specification</h2>
          <div
            class="relative flex items-center gap-2 px-3 py-2 rounded-lg text-sm bg-white"
          >
            <div
              class="w-5 h-5 rounded-md"
              :style="{
                backgroundColor: lightenColor(specMetadata.mainVariant.color),
                border: '2px solid ' + specMetadata.mainVariant.color,
              }"
            />
            <span class="font-medium">
              {{ specMetadata.mainVariant.name }}
            </span>
            <FloatingMenu trigger="hover" placement="bottom" :offset="[0, 10]">
              <template #activator>
                <div class="text-dark-neutral-300">
                  {{ additionalVariantsText }}
                </div>
              </template>
              <template #content>
                <div class="p-2 flex flex-col gap-2">
                  <div
                    class="flex items-center gap-2"
                    v-for="variant in specMetadata.variants"
                    :key="variant.id"
                  >
                    <div
                      class="w-5 h-5 rounded-md"
                      :style="{
                        backgroundColor: lightenColor(variant.color),
                        border: '2px solid ' + variant.color,
                      }"
                    />
                    <span class="font-medium">
                      {{ variant.name }}
                    </span>
                  </div>
                </div>
              </template>
            </FloatingMenu>
          </div>
        </div>
      </div>
    </div>
    <slot :specMetadata="specMetadata" />
  </div>
</template>
<script setup lang="ts">
import type { SpecificationMetadata } from "types";
import { FloatingMenu } from "ui-components";
import { lightenColor } from "utils";
import { computed } from "vue";

const props = defineProps<{
  specMetadata: SpecificationMetadata;
  goBackUrl: string;
  icon: string;
}>();

const additionalVariantsText = computed(() => {
  if (props.specMetadata?.variants?.length) {
    return ` and ${props.specMetadata?.variants?.length} other${
      props.specMetadata?.variants?.length === 1 ? "" : "s"
    }`;
  }
  return "";
});
</script>
